// @ts-ignore
import coreStore from '@/stores/core';

export const isFullSummary = () => {
  return (coreStore.safeGetStore('userStore').newABTestingConfigs as any)?.keyanswer_display_full_summary === 'display_full_summary';
};

export const isAutoAdapt = () => {
  return (coreStore.safeGetStore('userStore').newABTestingConfigs as any)?.keyanswer_auto_adapt_popup === 'auto_adapt';
};

export const isScrollToUnread = () => {
  return (coreStore.safeGetStore('userStore').newABTestingConfigs as any)?.keyanswer_scroll_to_unread === 'scroll_to_unread';
};
